import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/ambulatorio`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioEstatisticoConsulta(queryParms) {
            return repository.get(`${baseUrl}/relatorio-estatistico-consulta?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoAtendimento(params) {
            return repository.post(`${baseUrl}/relatorio-quantitativo-atendimento`, params, headers)
        },
        relatorioQuantitativoProducao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-quantitativo-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioRastreioFerida(params) {
            return repository.get(`${baseUrl}/relatorio-rastreio-ferida?${urlUtil.serialize(params)}`, headers)
        },
        relatorioProcedimento(queryParms) {
            return repository.get(`${baseUrl}/relatorio-procedimento?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioConsultaFinalizada(params) {
            return repository.get(`${baseUrl}/relatorio-consulta-finalizada?${urlUtil.serialize(params)}`, headers)
        },
    }
}
